<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span>
                                <router-link to="/customerlist" class="text-white pl-2 text-line">Customer</router-link>
                            </span>
                            <div>{{ $route.params.id == 'new' ? 'Create Customer' : 'Edit Customer'}}</div>
                        </div>
                    </div>
                </div>
            </h2>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <!-- Customer Details Section -->
            <div v-else class="start-overflow">
                <div class="create-company-container w-100">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-1 fw-500">Customer Details</span>
                            <span class="pointer pt-2" @click="showCustomerInfo">
                                <i v-if="!show_customer_details" class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="show_customer_details" class="p-6">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-6 mt-3 pl-0">
                                    <div class="d-flex justify-content-start tab-paddding">
                                        <div class="mr-8">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="text-secondary fs-14 fw-600 ml-5 mr-3" style="width:70px !important">Profile</div>
                                                <div class="form-check form-check-inline mr-7" style="width: 40px !important">
                                                    <label class="form-check-label check-label-dc radio-margin">
                                                        <input class="form-check-input" type="radio" value="profile_pic" v-model="pic_type"/>
                                                        <span class="radio-icon"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="pointer" @click="editPicture" style="position: relative;" :disabled="avatar_pic">
                                                <img class="mt-3 img-width" style="margin-left: 16px;width: 100px !important;" :src="profile_pic">
                                                <img src="/static/images/images-new-theme/icons/editgreynew.svg" height="25" style="position: absolute;bottom: 0 !important;">
                                            </div>
                                        </div>
                                        <div class="ml-2">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="text-secondary fs-14 fw-600 mr-3" style="width:74px !important">Avatar</span>
                                                <div class="form-check form-check-inline mr-7" style="width:40px !important">
                                                    <label class="form-check-label check-label-dc avatar-radio-margin">
                                                        <input class="form-check-input" type="radio" value="avatar" v-model="pic_type" />
                                                        <span class="radio-icon"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- @click="editAvatar" -->
                                            <div class="pointer mt-3" style="position: relative;">
                                                <img class="img-width" :src="avatar_pic || '/static/images/infra-logo.svg'" style="width: 100px !important;">
                                                <!-- <img src="/static/images/images-new-theme/icons/editgreynew.svg" height="25" style="position: absolute;bottom: 0 !important;"> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                            <div class="w-100">
                                                <span class="input-label">Company Name<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center"  v-if="$route.params.id == 'new'">
                                                    <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"  @select="selectedCompany($event), checkCustomer($event)"  @remove="removeSelected"
                                                        v-model="company_name"
                                                        :max-height="200"
                                                        v-validate="'required'"
                                                        :allow-empty="true"
                                                        :searchable="true"
                                                        :loading="company_name_loading"
                                                        :options="company_names"
                                                        :multiple="false"
                                                        :taggable="true"
                                                        :close-on-select="true"
                                                        :clear-on-select="false"
                                                        :preserve-search="true"
                                                        @search-change="searchCompanyName"
                                                        tag-placeholder="Add this as new customer"
                                                        placeholder="Search or Add a Company"
                                                        @tag="addTag"
                                                        label="name"
                                                        track-by="company_id"
                                                        name="company_name"
                                                        :preselect-first="false">
                                                        <!-- <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfloadCompanyName" />
                                                        </template> -->
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Company Names not found
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-left fw-600" @click="addCompany()">+Add Company Name</div>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                                <div v-else>
                                                    <div class="d-flex align-content-center mt-2" v-if="subsidiary_company_id !=''">
                                                        <input type="text" name="company_name" class="input-field input-width" disabled  v-model="company_name" placeholder="Enter Company Name" />
                                                    </div>
                                                    <div class="d-flex align-content-center mt-2" v-else>
                                                        <input type="text" name="company_name" class="input-field input-width"  v-model="company_name" placeholder="Enter Company Name" />
                                                    </div>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3"
                                                        v-show="errors.has('company_name')">{{errors.first('company_name')}}</span>
                                                </div>
                                                <span v-if="check_customer.status_id == 0" class="float-left text-danger mt-1">
                                                    Company Name Already Exist
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 margin-top-res mt-3">
                                            <div class="w-100">
                                                <span class="input-label">Customer Type<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                                <multiselect
                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    :searchable="true" v-validate="'required'" :options="customer_types" name="customer_type"
                                                    v-model="customer_type" placeholder="Select Customer Type">
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Customer Types not found
                                                        </div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3"
                                                        v-show="errors.has('customer_type')">Customer Type is required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 margin-top-res mt-6">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Territory</span>
                                                    <multiselect label="name" @search-change="searchTerritory" @open="fetchTerritory" track-by="id" :loading="territory_loading" :limit="1"  :limit-text="limitTerritory" v-model="territory" :blockKeys="['Delete']" @remove="removeTerritory" placeholder="Select Territory" class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2" id="ajaxgb" :options="territory_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" >
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center font-weight-bold" >Territories Not Found</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfTerritories" />
                                                        </template>
                                                    </multiselect>
                                                </div>
                                                <span class="pointer mt-4" @click="changeView()">
                                                    <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-3" style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 mt-6" v-if="$route.params.id == 'new' && selectedDept || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                            <div class="w-100">
                                                <span class="input-label">Department Name</span>
                                                <multiselect
                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    :searchable="true" :options="department_options" name="department_name" :loading="dept_loading"
                                                    v-model="department_name" placeholder="Select Department Name" label="name">
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Department Names not found
                                                        </div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
        
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 mt-6" v-else-if="$route.params.id == 'new' && !selectedDept || $route.params.id != 'new' &&  subsidiary_company_id ==''">
                                            <div class="w-100">
                                                <span class="input-label">Department Name</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="department_name" class="input-field input-width"
                                                        v-model="department_name" placeholder="Enter Department Name" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-8">
                                <div class="col-lg-4 col-md-4 col-sm-12 margin-top-res">
                                    <div class="w-100">
                                        <span class="input-label">Customer Status<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                        <multiselect v-validate="'required'" ref="customer_status_multiselectInput"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                            :searchable="true" :options="status_options" name="customer_status_multiselect"
                                            v-model="customer_status" placeholder="Select Customer Status">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Status not found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <div class="text-right pr-10">
                                            <span class="float-left text-danger mb-3"
                                                v-show="errors.has('customer_status_multiselect')">{{errors.first('customer_status_multiselect')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 margin-top-res">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <span class="input-label">Industry Type<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                            <multiselect v-validate="'required'" ref="industry_type_multiselectInput"
                                                class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                :searchable="true" :options="industries" name="industry_type_multiselect"
                                                v-model="industry_type" placeholder="Select Industry Type" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Industry Types not found
                                                    </div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <div class="text-right pr-10">
                                                <span class="float-left text-danger mb-3"
                                                    v-show="errors.has('industry_type_multiselect')">Industry Type is Required</span>
                                            </div>
                                        </div>
                                        <span class="mt-8" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                            <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <span class="input-label">Primary ID</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" v-validate="'email'"
                                                    class="input-field input-width email-text-valid" v-model="primary_email"
                                                    placeholder="Enter Primary ID" name="primary_email" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''"/>
                                            </div>
                                            <div class="text-right pr-10">
                                                <span class="float-left text-danger mb-3"
                                                    v-show="errors.has('primary_email')">{{errors.first('primary_email')}}</span>
                                            </div>
                                        </div>
                                        <span class="mt-8" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" >
                                            <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-6">
                                <div class="col-lg-4 col-md-4 col-sm-12 margin-top-res">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <span class="input-label">Tax ID</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" class="input-field input-width" v-model="tax_id" maxlength="30"
                                                    placeholder="Enter Tax ID" name="taxid" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" />
                                            </div>
                                        </div>
                                        <span class="mt-8" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                            <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                        </span>

                                    </div>
                                    <span class="input-field-length float-right fs-14" :class="{'text-padding':$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''}">{{ tax_id.length }}/30</span>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-6 col-sm-12 mt-2">
                                            <div class="w-100">
                                                <span class="input-label input-date-position">Date</span>
                                                <div class="d-flex align-items-center">
                                                    <date-picker
                                                        class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"
                                                        v-model="formatted_date" value-type="format" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" lang="en" type="date" format="MM-DD-YYYY"></date-picker>
                                                    <span class="mt-2" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                        <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                    </span>
                                                    <span class="mt-2" v-else>
                                                        <i class="icon icon-check-circle fs-30 ml-2 text-editable-yellow"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-2 margin-top-res">
                                            <div class="w-100">
                                                <span class="input-label input-date-position">Time</span>
                                                <div class="d-flex align-items-center">
                                                    <date-picker v-model="formatted_time" name="time"
                                                        class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                        format="HH:mm" type="time" placeholder="Select Time" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" value-type="format"
                                                        lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                        confirm-text="APPLY"></date-picker>
                                                    <!-- mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey date-picker-clock-svg-icon
                                                        <date-picker v-if="date_iso" class=" mx-left  meetinfdatetime time-height-customer calendar-down-arrow-grey" format="hh:mm" type="time" placeholder="HH:MM" lang="en" :clearable="false" :editable="false" v-model="formatted_time" :minute-step="1" confirm confirm-text="APPLY"></date-picker> -->
                                                    <!-- <date-picker  class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey" format="hh:mm" type="time" placeholder="HH:MM" lang="en" :clearable="false" :editable="false" v-model="formatted_time" :minute-step="1" confirm confirm-text="APPLY"></date-picker>{{formatted_time}} -->
                                                    <span class="mt-2" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                        <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                    </span>
                                                    <span class="mt-2" v-else>
                                                        <i class="icon icon-check-circle fs-30 ml-2 text-editable-yellow"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <span class="input-label">No. of Employees</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" class="input-field input-width" v-model="no_of_employees"
                                                    maxLength="20" v-validate="'max:150'"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    placeholder="Enter No. of Employees" name="number_of_employees" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''"/>
                                            </div>
                                        </div>
                                        <span class="mt-8" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                            <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                        </span>
                                    </div>
                                    <span class="input-field-length float-right fs-14">{{ no_of_employees.length }}/20</span>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div class="w-100">
                                        <span class="input-label">Sales Person<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                        <div class="d-flex align-items-center">
                                            <multiselect
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                name="sales_person_multiselect" :searchable="true" :options="sales_person_options"
                                                v-model="sales_person" :loading="employees_loading" ref="sales_person_multiselectInput"
                                                @search-change="searchAssigned" v-validate="{required:true}"
                                                track_by="id" label="full_name" placeholder="Select Sales Person">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfEmployees" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Sales Persons not
                                                        found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('sales_person_multiselect')">Sales Person is required</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Point of Contact Section -->
                            <div class="header-outer view-contact-tab px-3 mt-6">
                                <span class="fw-500">Point of Contact</span>
                                <!-- <span class="pointer" @click="showPointofContact()">
                                    <i v-if="contact_tab" class="icon-chevron-double-up text-white"
                                        style="font-size: 20px"></i>
                                    <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                                </span> -->
                            </div>
                            <div v-if="contact_tab" class="mt-3">
                                <div class="row mt-6">
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                        <div class="w-100" >
                                            <span class="input-label">Point of Contact<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                            <div class="d-flex align-items-center">
                                                <multiselect
                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    name="point_contact" :searchable="true" :options="poc_options"
                                                    v-validate="'required'"
                                                    v-model="point_contact" :loading="poc_loading" @select="selectedPointContact" @remove="removeSelectedPoc"
                                                    @search-change="searchPoc"
                                                    track_by="id" label="full_name" placeholder="Select Point of Contact">
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="reachedEndOfPoc"/>
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Point of Contact not
                                                            found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found
                                                        </div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="text-right pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('point_contact')">Point of Contact is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" :class="{'col-lg-4':selectedData}">
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <span class="input-label">First Name<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" v-validate="'required'" maxLength="50"
                                                        class="input-field input-width" ref="point_of_contact_firstInput"
                                                        v-model="point_of_contact_first_name" placeholder="Enter First Name"
                                                        name="point_of_contact_first" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" />
                                                </div>
                                            </div>
                                            <span class="mt-8" v-if="$route.params.id == 'new' && selectedPoc || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                            </span>
                                        </div>
                                        <span class="float-left text-danger mb-3"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('point_of_contact_first')">Point of Contact - First Name
                                            is required</span>
                                        <span class="input-field-length float-right fs-14">{{ point_of_contact_first_name.length }}/50</span>

                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" :class="{'col-lg-4':selectedData}">
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <span class="input-label">Last Name<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" v-validate="'required'" ref="point_of_contact_lastInput"
                                                        class="input-field input-width" name="point_of_contact_last" maxLength="50"
                                                        v-model="point_of_contact_last_name" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''"
                                                        placeholder="Enter Last Name" />
                                                </div>
                                            </div>
                                             <span class="mt-8" v-if="$route.params.id == 'new' && selectedPoc || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                            </span>
                                        </div>
                                        <span class="float-left text-danger mb-3"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('point_of_contact_last')">Point of Contact - Last Name is
                                            required</span>
                                        <span class="input-field-length float-right fs-14">{{ point_of_contact_last_name.length }}/50</span>
                                    </div>
                                </div>
                                <div class="row mt-6">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <span class="input-label">Email ID<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-3">
                                                    <input v-validate="'required|email'" type="email" ref="emailInput" maxLength="50"
                                                        class="input-field input-width email-text-valid" v-model="email"
                                                        placeholder="Enter Email ID" name="email" :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''"/>
                                                </div>
                                            </div>

                                            <span class="mt-8" v-if="$route.params.id == 'new' && selectedPoc || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                            </span>
                                        </div>
                                        <span class="invalid-feedback-form text-danger float-left"
                                        style="text-transform: none !important;width: 80% !important;"
                                        v-show="errors.has('email')">{{errors.first('email')}}</span>
                                        <span class="input-field-length float-right fs-14">{{ email.length }}/50</span>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="w-100">
                                            <span class="input-label">Mobile Number<sup class="pl-1 fs-14 text-danger">*</sup></span>
                                            <div class="d-flex align-items-center">
                                                <div v-if="$route.params.id != 'new'" class="w-100">
                                                    <vue-tel-input :defaultCountry="contact_mobile_number.country_code"
                                                        @onInput="contactPhoneInput" v-bind="bindProps"
                                                        class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                                        name="contact_mobile_number"
                                                        v-model="contact_mobile_number.phone_number"
                                                        v-validate="{required:true,min:10}"
                                                        :valid-characters-only="true" :maxLen="15"
                                                        placeholder="Enter Mobile Number" :disabledFormatting="false"
                                                        style="width:100% !important; margin-right: 30px;" :disabled="$route.params.id == 'new' && selectedPoc || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                    </vue-tel-input>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('mobile_number')">{{errors.first('mobile_number')}}</span>
                                                </div>
                                                <div v-else class="w-100">
                                                    <vue-tel-input @onInput="contactPhoneInput" v-bind="bindProps"
                                                        class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                                        name="contact_mobile_number"
                                                        v-model="contact_mobile_number.phone_number"
                                                        v-validate="{required:true,min:10}"
                                                        :valid-characters-only="true" :maxLen="15"
                                                        placeholder="Enter Mobile Number" :disabledFormatting="false"
                                                        style="width:100% !important; margin-right: 30px;"
                                                        :disabled="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''" >
                                                    </vue-tel-input>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('mobile_number')">{{errors.first('mobile_number')}}</span>
                                                </div>
                                                <span class="mt-5" v-if="$route.params.id == 'new' && selectedPoc || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                                    <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                </span>


                                            </div>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('contact_mobile_number')">{{errors.first('contact_mobile_number')}}</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Additional Information Section -->
                            <div class="header-outer view-contact-tab px-3 mt-6">
                                <span class="fw-500">Additional Information</span>
                                <!-- <span class="pointer" @click="showAddInfo()">
                                    <i v-if="add_info_tab" class="icon-chevron-double-up text-white"
                                        style="font-size: 20px"></i>
                                    <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                                </span> -->
                            </div>
                            <div v-if="add_info_tab" class="mt-3">
                                <div v-if="additional_info.length == 0 || check_visibility"
                                    class="font-weight-bold mt-4 text-center">
                                    No Additional Fields Found
                                </div>
                                <div class="row mt-6" v-else-if="additional_info.length">
                                    <div class="col-lg-4 col-md-4 col-sm-12"
                                        v-for="(info,additional_index) in additional_info" :key="additional_index"
                                        v-show="info.visibility">
                                        <div class="form-group contactGroup" v-if="info.field_type == 'input_field'">
                                            <span
                                                class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                            <input class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-if="info.data_type == 'text'" :maxLength="info.character_limit"
                                                v-model="info.value" type="text"
                                                :placeholder="'Enter ' + info.field_name.replace('_',' ')" />
                                            <input class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-else-if="info.data_type == 'decimal'" v-model.number="info.value"
                                                v-on:keypress="isNumber($event)" type="text"
                                                :placeholder="'Enter ' + info.field_name.replace('_',' ')" />
                                            <input class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-else-if="info.data_type == 'integer'" v-model.number="info.value"
                                                type="number" :placeholder="'Enter ' + info.field_name.replace('_',' ')"
                                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' />
                                            <span class="highlightContact"></span>
                                            <span class="barContact"></span>
                                            <span class="pull-right text-right text-grey font-600 fs-12 pt-1"
                                                v-if="info.data_type == 'Text'">{{ info.limit - info.value.length}}/{{info.limit}}</span>
                                        </div>
                                        <div class="form-group"
                                            v-if="info.field_type == 'selection_field' && info.data_type == 'radio_button' && info.hasOwnProperty('options')">
                                            <span
                                                class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                            <div class="mt-2">
                                                <el-radio-group v-model="info.value" v-for="(option,option_index) in info.options"
                                                    :key="option_index" class="w-200px">
                                                    <el-radio class="ml-2 pt-2" @change="$forceUpdate()"
                                                        :label="option.value" :id="option">{{option.value}}</el-radio>
                                                </el-radio-group>
                                            </div>
                                        </div>
                                        <div class="pt-0"
                                            v-if="info.field_type=='input_field' && info.data_type=='date'">
                                            <date-picker
                                                class="cal-icon date-input-customer calendar-edit-per input-field pt-0 pb-0 pr-0"
                                                v-model="info.value" value-type="format" lang="en" type="date"
                                                @change="$forceUpdate()" format="YYYY-MM-DD" :clearable="false"></date-picker>
                                        </div>
                                        <div class="form-group contactGroup" style="margin-top: 0px;"
                                            v-if="info.field_type == 'selection_field' && info.data_type == 'drop_down'">
                                            <span
                                                class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                            <multiselect @close="$forceUpdate()" v-model="info.value"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-1"
                                                id="ajaxnew" :placeholder="'Select ' + info.field_name.replace('_',' ')"
                                                :options="info.options" :multiple="false" :searchable="true"
                                                label="value" :internal-search="true" :clear-on-select="false"
                                                :close-on-select="true" :max-height="200" :show-no-results="true"
                                                :hide-selected="false" open-direction="top" >
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found
                                                    </div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Associated Contact Section -->
                        <div class="create-company-header d-flex align-items-center justify-content-between mt-3">
                            <span class="fs-14 pl-4 text-white ml-1 fw-500">Associated Contacts</span>
                            <span class="pointer pt-2" @click="showAssociatedContact">
                                <i v-if="!show_associated_contact" class="icon-chevron-double-down
                                    text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="show_associated_contact" class="p-2">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-for="(contact, contact_index) in associated_contact" :key="contact_index" name="contact-display">
                                    <div class="remainder-list mr-5 px-4" v-if="!associated_contact.hasOwnProperty('is_deleted')" style="max-height: 120px;overflow: scroll;margin-bottom: 10px;">
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow fs-14 fw-600 word-break-all text-truncate" :title="contact.contact_name.full_name">
                                                {{contact.contact_name.full_name}}
                                            </div>
                                            <div class="d-flex align-items-center pl-3">
                                                <div class="pointer" @click="addAssociatedContact(contact_index,'edit')">
                                                    <i class="icon icon-pencil new-blue-text fs-20"></i>
                                                </div>
                                                <div class="ml-2 pointer" @click="deleteContact(contact_index)">
                                                    <i class="icon icon-trash new-blue-text fs-20"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-1 text-secondary fs-14 text-truncate" :title="contact.job_title">
                                            <span class="text-secondary">Job Title:</span><span
                                                class="ml-2 word-break-all">{{contact.job_title || '-'}}</span>
                                        </div>
                                        <div class="mt-1 text-secondary fs-14 text-truncate" :title="contact.email_id">
                                            <span class="">Email ID:</span><span
                                                class="ml-2 word-break-all">{{contact.email_id}}</span>
                                        </div>
                                        <div class="mt-1 text-secondary fs-14 text-truncate" :title="contact.phone_number.phone_number">
                                            <span class="">Phone Number:</span><span
                                                class="ml-2 word-break-all">{{contact.phone_number.phone_number}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" name="address-display" v-for="(company, company_index) in company_branch" :key="company_index">
                                    <div class="remainder-list mx-5 p-3 pt-4 address-card-height" >
                                        <div class="fs-14 fw-700 text-flow word-break-all">{{company.branch_name}}</div>
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow word-break-all">
                                                <span>{{company.building_no||''}}</span>
                                                <span v-if="company.building_no">,</span>
                                                <span>{{company.street1||''}}</span>
                                                <span v-if="company.street1">,</span>
                                                <span>{{company.township||''}}</span>
                                                <span v-if="company.township">,</span>
                                                <span>{{company.city}}</span>
                                                <span v-if="company.city">,</span>
                                                <span>{{company.state||''}}</span>
                                                <span v-if="company.state">,</span>
                                                <span>{{company.country||''}}</span>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Pincode : </span>
                                            <span class="ml-2">{{company.zip_code  || '-'}}</span>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Customer Email ID : </span>
                                            <span class="ml-2">{{company.email || '-'}}</span>
                                        </div>
                                        <div class="mt-1" v-if="company.phone_number">
                                            <span class="fw-500">Customer Number :</span>
                                            <span class="ml-2 word-break-all">{{company.phone_number.phone_number  || '-'}}</span>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Links :</span>
                                            <span class="ml-2 word-break-all">{{company.website  || '-'}}</span>
                                        </div>


                                    </div>
                                </div>
                            </div> v-else-if="$route.params.id == 'new' && !selectedData || $route.params.id != 'new' &&  subsidiary_company_id ==''" -->
                            <!-- <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-for="(contact, contact_index) in associated_contact" :key="contact_index" name="address-display">
                                    <div class="remainder-list mr-5 " v-if="!associated_contact.hasOwnProperty('is_deleted')" style="max-height: 120px;overflow: scroll;margin-bottom: 10px;">
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow word-break-all">
                                                {{contact.contact_name.company_name}}
                                            </div>
                                                <div class="d-flex align-items-center pl-3">
                                                    <div class="pointer" @click="addCompanyAddress(contact_index,'edit')">
                                                        <i class="icon icon-pencil new-blue-text fs-20"></i>
                                                    </div>
                                                    <div class="ml-2 pointer" @click="deleteAddress(contact_index)">
                                                        <i class="icon icon-trash new-blue-text fs-20"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Job Title</span><span
                                                    class="ml-2 word-break-all">{{contact.job_title}}</span>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Email ID</span><span
                                                    class="ml-2 word-break-all">{{contact.email_id}}</span>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Phone Number</span><span
                                                    class="ml-2 word-break-all">{{contact.phone_number.phone_number}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="d-flex justify-content-between align-items-center" v-if="$route.params.id == 'new'">
                                <div class="text-danger"></div>
                                <div class="pt-5 px-4 text-right">
                                    <button class="btn btn-des-small mt-2  new-field-btn d-block ml-auto mb-3" :disabled="hideAddContactButton || associated_contact.length > 4"
                                        @click="addAssociatedContact(null,'add')">+ Add Contact
                                        <hollow-dots-spinner v-if="hideAddContactButton" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                    </button>
                                </div>
                                <!-- <div v-else class="pt-5 px-4 text-right">
                                    <button class="btn btn-des-small mt-2  new-field-btn d-block ml-auto mb-3" disabled style="position: relative;">+ Add Contact
                                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                    </button>
                                </div> -->

                            </div>
                        </div>
                        <!-- Branch Address Section -->
                        <div class="create-company-header d-flex align-items-center justify-content-between mt-3">
                            <span class="fs-14 pl-4 text-white ml-1 fw-500">Branch Address</span>
                            <span class="pointer pt-2" @click="showCompanyAddress">
                                <i v-if="!show_company_address" class="icon-chevron-double-down
                                    text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="show_company_address" class="p-2">
                            <div class="row" v-if="$route.params.id == 'new' && selectedData || $route.params.id != 'new' &&  subsidiary_company_id !=''">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" name="address-display" v-for="(company, company_index) in company_branch" :key="company_index">
                                    <div class="remainder-list mx-5 p-3 pt-4 address-card-height" >
                                        <div class="fs-14 fw-700 text-flow word-break-all">{{company.branch_name}}</div>
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow word-break-all">
                                                <span>{{company.building_no||''}}</span>
                                                <span v-if="company.building_no">,</span>
                                                <span>{{company.street1||''}}</span>
                                                <span v-if="company.street1">,</span>
                                                <span>{{company.township||''}}</span>
                                                <span v-if="company.township">,</span>
                                                <span>{{company.city}}</span>
                                                <span v-if="company.city">,</span>
                                                <span>{{company.state||''}}</span>
                                                <span v-if="company.state">,</span>
                                                <span>{{company.country||''}}</span>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Pincode : </span>
                                            <span class="ml-2">{{company.zip_code  || '-'}}</span>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Customer Email ID : </span>
                                            <span class="ml-2">{{company.email || '-'}}</span>
                                        </div>
                                        <div class="mt-1" v-if="company.phone_number">
                                            <span class="fw-500">Customer Number :</span>
                                            <span class="ml-2 word-break-all">{{company.phone_number.phone_number  || '-'}}</span>
                                        </div>
                                        <div class="mt-1">
                                            <span class="fw-500">Links :</span>
                                            <span class="ml-2 word-break-all">{{company.website  || '-'}}</span>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div v-else-if="$route.params.id == 'new' && !selectedData || $route.params.id != 'new' &&  subsidiary_company_id ==''"  class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-for="(address, address_index) in address"
                                    :key="address_index" name="address-display">
                                    <div class="remainder-list mr-5 " v-if="!address.hasOwnProperty('is_deleted')" style="max-height: 120px;overflow: scroll;margin-bottom: 10px;">
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow word-break-all">
                                                {{address.address.building_number + ((address.address.building_number).length > 0 ?  ", " : '')}}
                                                {{address.address.street + ((address.address.street).length > 0 ?  ", " : '')}}
                                                {{address.address.township + ((address.address.township).length > 0 ?  ", " : '')}}
                                                {{address.address.city + ((address.address.city).length > 0 ?  ", " : '')}}
                                                {{address.address.state + ((address.address.state).length > 0 ?  ", " : '')}}
                                                {{address.address.zip_code + ((address.address.zip_code).length > 0 ?  ", " : '')}}
                                                {{address.address.country }}
                                            </div>
                                                <!-- {{address.address.building_number}}{{address.address.township}},{{address.address.city}},{{address.address.state}},{{address.address.country}}</div> -->
                                                <div class="d-flex align-items-center pl-3">
                                                    <div class="pointer" @click="addCompanyAddress(address_index,'edit')">
                                                        <i class="icon icon-pencil new-blue-text fs-20"></i>
                                                    </div>
                                                    <div class="ml-2 pointer" @click="deleteAddress(address_index)">
                                                        <i class="icon icon-trash new-blue-text fs-20"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Link</span><span
                                                    class="ml-2 word-break-all">{{address.customer_links[0] ? address.customer_links[0] : '-'}}</span>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Emails</span><span
                                                    class="ml-2 word-break-all">{{address.alternate_emails[0] ? address.alternate_emails[0] : '-'}}</span>
                                            </div>
                                            <div class="mt-1">
                                                <span class="fw-600">Branch Name</span><span
                                                    class="ml-2 word-break-all">{{address.branch_name ? address.branch_name : '-'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center" v-if="$route.params.id == 'new' && !selectedData || $route.params.id != 'new' &&  subsidiary_company_id==''">
                                    <div class="text-danger" id="addressCheck"></div>
                                    <div v-if="hideAddBranchButton == false" class="pt-5 px-4 text-right">
                                        <button class="btn btn-des-small mt-2  new-field-btn d-block ml-auto mb-3"
                                            @click="addCompanyAddress(null,'add'), clearAddressCheck()">+ Add Branch</button>
                                    </div>
                                    <div v-else class="pt-5 px-4 text-right">
                                        <button class="btn btn-des-small mt-2  new-field-btn d-block ml-auto mb-3" disabled style="position: relative;">+ Add Branch
                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                        </button>
                                    </div>

                                </div>

                            </div>
                            <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button class="btn new-cancel-button" @click="cancel()">Cancel</button>
                                <button v-if="!selectedData" class="btn new-save-button ml-5" @click="saveCustomer(), addressCheck()">Save</button>
                                <button v-else class="btn new-save-button ml-5" @click="saveCustomer()">Save</button>
                            </div>
                            <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button class="btn btn-new-cancel" style="border: none !important;" disabled>Cancel</button>
                                <button v-if="!selectedData" class="btn new-save-button ml-5" style="position: relative;" disabled>Save
                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                                <button v-else class="btn new-save-button ml-5" style="position: relative;" disabled>Save
                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
            <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
            <success-message
                :message="$route.params.id == 'new' ? 'Customer Created successfully': 'Customer Updated successfully'"
                modal_name="success-message" @hideSuccess="hideSuccess"></success-message>
            <company-address v-if="add_company_address" modal_name="addCompanyAddress"
                @hideCompanyAddress="hideCompanyAddress" @saveCompanyAddress="saveCompanyAddress"></company-address>
            <associated-contact v-if="add_associated_contact" :view_mode="view_mode" :added_contact="added_contact" modal_name="addAssociatedContact"
                @hideAssociatedContact="hideAssociatedContact" @saveAssociatedContact="saveAssociatedContact"></associated-contact>
            <edit-picture modal_name="editPic" hide @uploaded="uploaded" @deletePic="deletePic"></edit-picture>
            <edit-avatar modal_name="editAvatar" @newAvatar="newAvatar"></edit-avatar>
        </div>
</template>
<script>
    const EditPicture = () => import("../alertModals/EditPicture");
    const EditAvatar = () => import("../alertModals/EditAvatar");
    import leads from '../mixins/leads';
    import convert from '../mixins/convert';
    import products from "../mixins/products.js";
    import customers from '../mixins/customer';
    import settings from "../mixins/settings.js";
    import {
        EventBus
    } from '../eventBus/nav-bar-event';
    import moment from "moment-timezone";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    const SuccessMessage = () => import("../SuccessMessage");
    const CompanyAddress = () => import("./AddCompanyAddress.vue");
    const AssociatedContact = () => import("./AddAssociatedContact.vue");
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import { debounce } from 'lodash';
    import { HollowDotsSpinner } from "epic-spinners";
    export default {
        data() {
            return {
                disableButtonAndDisplayLoader: false,
                bindProps: {
                    mode: "international",
                    defaultCountry: "US"
                },
                hideAddContactButton: false,
                hideAddBranchButton: false,
                point_contact:'',
                subsidiary_company_id:'',
                show_company_name:false,
                department_options:[],
                dept_loading:false,
                selectedDept:false,
                selectedData:false,
                selectedPoc:false,
                poc_loading:false,
                poc_scrollable:false,
                poc_options:[],
                poc_visible :false,
                temp_poc:'',
                poc_count: 0,
                contact_tab: true,
                add_info_tab: true,
                ajaxCallInProgress: false,
                add_company_address: false,
                add_associated_contact: true,
                show_customer_details: true,
                show_company_address: true,
                show_associated_contact: true,
                selected_lead: "Individual",
                company_name: [],
                temp_company_name: '',
                companies: [],
                company_names:[],
                company_name_loading:false,
                customer_types: ['Domestic', 'International'],
                customer_type: null,
                branches: [],
                departments: [],
                department_name: "",
                status_options: ['Demo','Existing Customer','Follow Up','New Customer'],
                customer_status: null,
                contact_mobile_number: {
                    phone_number: "",
                    dial_code: "",
                    country_code: "",
                    phone_type: "mobile"
                },
                industries: ["Accommodation and Food Services","Administrative and Support, Waste Management and Remediation Services","Agriculture, Forestry, Fishing and Hunting","Arts, Entertainment and Recreation","Construction","Developer","Educational Services","EPC","Finance and Insurance","F&B","Health Care and Social Assistance","Information and Cultural Industries","Management of Companies and Enterprises","Manufacturing","Mining, Quarrying, and Oil and Gast Extraction","Other Businesses","Other Services (except public administration)","Professional, Scientific and Technical Services","Public Administration","Real Estate and Rental and Leasing","Residential Installation","Retail Trade","Transportation and Warehousing","Supplier","Utilities","Wholesale Trade"],
                industry_type: null,
                point_of_contact_options: [],
                point_of_contact_first_name: "",
                point_of_contact_last_name: "",
                primary_email: "",
                taxid: "",
                tax_id:"",
                email: "",
                customer_mobile_number: {
                    phone_number: "",
                    dial_code: "",
                    country_code: "",
                    phone_type: ""
                },
                phone: {
                    number: "",
                    isValid: false,
                    country: undefined,
                    dial_code: "91",
                },
                address: [],
                address_length: 0,
                contact_length: 0,
                sales_person: null,
                number_of_employees: null,
                date_iso: false,
                date: new Date(),
                formatted_date: moment(new Date().toUTCString()).format("MM-DD-YYYY"),
                formatted_time: moment(new Date().toUTCString()).format("HH:mm"),
                sales_person_options: [],
                territory:'',
                territory_options:[],
                temp_territories: [],
                temp_companyNames: [],
                territory_loading:false,
                territory_count:0,
                companyNames_count:0,
                territory_scrollable: false,
                companyNames_scrollable: false,
                territory_visible: false,
                companyNames_visible: false,
                temp_employees: [],
                employees_loading: false,
                employee_count: 0,
                employee_scrollable: false,
                employee_visible: false,
                skip: 0,
                limit: 10,
                sucess_customer: false,
                success_msg: "",
                warning_msg: "",
                customer_id: null,
                selected_company_address_index: null,
                selected_associated_contact_index: null,
                no_of_employees: "",
                split_time: "",
                products_options: [],
                interested_product_name: [],
                products_loading: false,
                products_count: 0,
                products_loading: false,
                products_scrollable: false,
                products_visible: false,
                temp_products: [],
                products_options: [],
                additional_info: [],
                check_visibility: false,
                company_branch:[],
                selected_company_id: '',
                associated_contact: [],
                avatar_pic: "/static/images/infra-logo.svg",
                pic_type: "profile_pic",
                profile_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/No Picture.svg",
                temp_associated_contact: [],
                check_customer: [],
                added_contact: [],
                view_mode: "create",
                associated_contact_index: null
            }
        },
        mixins: [leads, convert, customers, products, settings],
        components: {
            SweetModal,
            CompanyAddress,
            SuccessMessage,
            HalfCircleSpinner,
            HollowDotsSpinner,
            AssociatedContact,
            EditPicture,
            EditAvatar
        },
        methods: {
            async checkCustomer(value) {
                let params = {
                    "customer_name": value.name
                };
                this.check_customer = await this.alreadyCustomerExist(params);
            },
            editPicture() {
                if (this.pic_type == "profile_pic") {
                    EventBus.$emit("profile_picture", this.profile_pic)
                    this.$modal.show("editPic");
                }
            },
            editAvatar() {
                if (this.pic_type == "avatar") {
                this.$modal.show("editAvatar");
                }
            },
            //getting the url of uploaded pic
            uploaded(url) {
                this.profile_pic = url;
            },
            //getting the url of avatar
            newAvatar(url) {
                this.avatar_pic = url;
            },
            //setting the pic after deleting the picture
            deletePic() {
                this.profile_pic = "/static/images/No Picture.svg";
            },
            addAssociatedContact(index, mode) {
                this.view_mode = "create"
                if(mode == 'add'){
                    this.hideAddContactButton = true;
                }
                this.selected_associated_contact_index = index
                this.associated_contact_index = index
                this.add_associated_contact = true
                localStorage.setItem("selected_associated_contact", null)
                if (this.selected_associated_contact_index != null) {
                    localStorage.setItem("selected_associated_contact", JSON.stringify(this.associated_contact[index]))
                }
                setTimeout(() => {
                    this.hideAddContactButton = false;
                    this.$modal.show("addAssociatedContact");
                }, 500);
            },
            deleteContact(index) {
                if (this.$route.params.id != 'new' && this.associated_contact[index].hasOwnProperty('id')) {
                    this.associated_contact[index]['is_deleted'] = true
                    this.associated_contact['count'] = this.contact_length + 1
                    this.contact_length = this.associated_contact.count
                    var get_add_section = document.getElementsByName('contact-display')[index];
                    get_add_section.classList.add('contact-none');
                } else if (this.$route.params.id == 'new' && !this.associated_contact[index].hasOwnProperty('id')) {
                    this.associated_contact.splice(index, 1);
                    this.added_contact.splice(index, 1);
                } else if (this.$route.params.id != 'new' && !this.associated_contact[index].hasOwnProperty('id')) {
                    this.associated_contact.splice(index, 1);
                    this.added_contact.splice(index, 1);
                }
                this.$forceUpdate()
            },
            hideAssociatedContact() {
                this.add_associated_contact = false
            },
            saveAssociatedContact(value){
                let contact_value = value
                if (this.selected_associated_contact_index != null) {
                    this.associated_contact[this.associated_contact_index].contact_name = contact_value.contact_name
                    this.associated_contact[this.associated_contact_index].job_title = contact_value.job_title
                    this.associated_contact[this.associated_contact_index].email_id = contact_value.email_id
                    this.associated_contact[this.associated_contact_index].phone_number = contact_value.phone_number
                } else if (this.selected_company_address_index == null) {
                    this.associated_contact.push({
                        contact_name:contact_value.contact_name,
                        job_title: contact_value.job_title,
                        email_id: contact_value.email_id,
                        phone_number: contact_value.phone_number,
                    })
                    this.added_contact.push({
                        contact_name:contact_value.contact_name,
                        job_title: contact_value.job_title,
                        email_id: contact_value.email_id,
                        phone_number: contact_value.phone_number,
                    })
                }
            },
            //convert the time format
            /**@params = str */
            convertView(str) {
                var date = str.slice(0,11).split("/"),
                mnth = date[1],
                day = date[0],
                year = date[2];
                var newDate = [year,mnth,day].join("-");
                return newDate

            },
            //add the compoany name manually
            /**@params = newTag */
            addTag(newTag) {
                const tag = {
                    name: newTag
                };
                this.company_names.push(tag);
                this.company_name = tag;
                this.selectedCompany(this.company_name)
            },
            /*Api call to search company*/
            /**@params = search */
            // async searchCompany(search){
            //     this.company_names = [];
            //     let response = await this.getContactNameList({
            //         search_key: this.search,
            //     })
            //     this.company_names = response.response
            //     console.log(this.company_names)
            // },
            /*Api call to fetch company*/
            // async fetchCompanyName(){
            //     this.company_names = [];
            //     this.company_name_loading = true
            //     let response = await this.getContactNameList({
            //         search_key: '',
            //     })

            //     this.company_names = response.response
            //     console.log(this.company_names)
            //     this.company_name_loading = false
            // },
            async searchCompanyNameDobouncer(){
                this.company_name_loading = true
                /**@params = skip,@params = limit,@params = search_key, @params = hierarchy_level*/
                this.company_names = [];
                let params = {
                    enabled: "as_customer",
                    filter_product: true,
                    search_key: ""
                }
                let response = await this.getCompanyNameList(params)
                this.company_names = response.response
                // this.companyNames_count = response.response.length;
                this.company_name_loading = false
            },
            async loadCompanyName(){
                /**@params = skip,@params = limit,@params = search_key, @params = hierarchy_level*/
                this.company_names = [];
                let params = {
                    enabled: "as_customer",
                    filter_product: true,
                    search_key: ""
                }
                let response = await this.getCompanyNameList(params)
                this.company_names = response.response
                // this.companyNames_count = response.response.length;
                // this.companyNames_scrollable = false;
            },
            // async reachedEndOfloadCompanyName(reached) {
            //     this.companyNames_visible = reached
            //     if (reached) {
            //         if (this.companyNames_scrollable == false) {
            //             this.company_name_loading = true
            //             let params = {
            //                     enabled: "as_customer",
            //                     filter_product: true,
            //                     skip: this.companyNames_count,
            //                     limit:this.limit,
            //                     search_key: ""
            //                 }
            //             let response = await this.getCompanyNameList(params)
            //             this.temp_companyNames = response.response.length;
            //             if (response.skip == this.companyNames_count) {
            //                 if (this.temp_companyNames > 0) {
            //                     let tempFiles = response.response;
            //                     tempFiles.forEach(el => {
            //                         this.company_names.push(el);
            //                     });
            //                     this.companyNames_count += response.response.length;
            //                     this.company_name_loading = false
            //                 } else {
            //                     this.companyNames_scrollable = true
            //                     this.company_name_loading = false
            //                 }
            //             }
            //             this.company_name_loading = false
            //         }
            //     }
            // },
            //if company selected from dropdown
            /**@params = value */
            selectedCompany(value){
                this.selected_company_id = value.company_id;
                this.sales_person = null;
                this.point_contact = '';
                this.point_of_contact_first_name = '';
                this.point_of_contact_last_name = '';
                this.email = '';
                this.contact_mobile_number.phone_number = "";
                this.contact_mobile_number.dial_code = "";
                this.contact_mobile_number.country_code = "";
                this.contact_mobile_number.phone_type = "mobile";
                if(value.company_id ){
                    this.selectedData = true;
                    this.selectedDept = true;
                    this.addCompanyBranch(value);
                    this.addCompanyDepartment(value);
                    this.addCompanyCustomer(value);
                } else{
                    this.removeSelected()
                }
            },
            //remove the selected company and reset the fields
            removeSelected(){
                this.selectedData = false;
                this.selectedDept = false;
                this.removeSelectedPoc();
                this.department_name = ""
                this.no_of_employees = ""
                this.industry_type = null
                this.primary_email = ""
                this.tax_id = ""
                this.formatted_date = moment(new Date().toUTCString()).format("MM-DD-YYYY")
                this.formatted_time = moment(new Date().toUTCString()).format("HH:mm")
            },
            //selected the POC data
            /**@params = value */
            selectedPointContact(value){
                this.selectedPoc = true;
                setTimeout(() => {
                    this.searchPoc();
                },2000)
                this.addPoc(value)
            },
            //remove the selected POC
            removeSelectedPoc(){
                this.selectedPoc = false;
                this.point_of_contact_first_name = ""
                this.point_of_contact_last_name = ""
                this.email = ""
                this.contact_mobile_number.phone_number = ""
            },
            //API call to add contact branch data
            /**@params = value */
            async addCompanyBranch(value){
                let response = await this.getContactBranch({
                    /**@params = skip,@params = limit,@params = search_key, @params = company_id */
                    skip:this.skip,
                    limit:this.limit,
                    search_key: '',
                    company_id : value.company_id
                })
                this.company_branch = response.response

            },
            //API call to add contact department data
            /**@params = value */
            async addCompanyDepartment(value){
                this.dept_loading = true;
                /**@params = skip,@params = limit,@params = search_key, @params = company_id */
                let params = {
                    skip:this.skip,
                    limit:this.limit,
                    search_key: '',
                    company_id : value.company_id || value
                };
				let response = await this.getContactDeaprtment(params);
                this.department_options = response.response
                this.dept_loading = false;
            },
            //Api call to add customer data
            /**@params = value */
            async addCompanyCustomer(value){
                if(value.company_id){
                    let response = await this.getContactCustomer({
                        company_id: value.company_id,
                    })
                    let customer = response.response
                    this.no_of_employees = customer.no_of_employees
                    this.industry_type = customer.industry_type
                    this.primary_email = customer.info_email
                    this.tax_id = customer.tax_id
                    // this.formatted_date = this.convertView(customer.date_of_incorporation) || ''
                    // this.formatted_time = ''
                }
            },
            //Api call to add POC
            /**@params = val */
            async addPoc(val){
                this.poc_options = [];
                this.poc_loading = true
                let response = await this.getPointOfContact({
                    user_id: val.user_id,
                })
                let data = response.response
                data.forEach((x,index) => {
                    this.point_of_contact_first_name = x.first_name.value,
                    this.point_of_contact_last_name = x.last_name.value,
                    this.email = x.primary_email.value,
                    this.contact_mobile_number = x.primary_phone.value
                });
                this.poc_loading = false
            },
            //Api call to search POC details
            /**@params = item */
            async searchPocDobouncer(item) {
                this.poc_loading = true
                /**@params = skip,@params = limit,@params = search_key, @params = company_id, @params = sort_key, @params = sort_value*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: item,
                    company_id: this.selected_company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let response = await this.getAssigned(params)
                this.poc_options = response.response
                this.poc_count = this.poc_options.length
                this.poc_loading = false
                this.poc_scrollable = false
            },
            //Lazy loading of POC
            /**@params = reached */
            async reachedEndOfPoc(reached) {
                this.poc_visible = reached
                if (reached) {
                    if (this.poc_scrollable == false) {
                        this.poc_loading = true
                        let response = await this.getAssigned({
                            skip: this.poc_count,
                            limit: 10,
                            search_key: "",
                            company_id: this.selected_company_id,
                            sort_key:'full_name',
                            sort_value:1
                        })
                        this.temp_poc = response.response.length;
                        if (response.skip == this.poc_count) {
                            if (this.temp_poc > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    if(el.user_access !== 'owner'){
                                        this.poc_options.push(el);
                                    }
                                });
                                this.poc_options = this.poc_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.poc_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.poc_count += response.response.length;
                                this.poc_loading = false
                            } else {
                                this.poc_scrollable = true
                                this.poc_loading = false
                            }
                        }
                        this.poc_loading = false
                    }
                }
            },
            //checking the type number
            /**@params = evt, @params =index */
            isNumber: function (evt, index) {
                evt = evt ? evt : window.event
                var charCode = evt.which ? evt.which : evt.keyCode
                if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true
                }
            },
            //checking the type text
            /**@params = evt, @params =index */
            isAlphabet: function (evt, index) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
                    evt.preventDefault()
                }
                return true;
            },
            //redirecting to the territory settings
            changeView(){
                let territory = true
                let routeData = this.$router.resolve({name: 'Settings', query: {territory:territory}});
                window.open(routeData.href, '_blank');
            },
            //APi call to search territory
            /**@params = search */
            async searchTerritoryDobouncer(search) {
                this.territory_loading = true
                /**@params = skip,@params = limit,@params = search_key, @params = hierarchy_level*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: search,
                    hierarchy_level:'all'
                }
                let response = await this.getTerritoryList(params)
                this.territory_options = response.response
                this.territory_options = this.territory_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.territory_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.territory_count = this.territory_options.length
                this.territory_loading  = false
                this.territory_scrollable = false
            },
            //API call to fetch territory
            async fetchTerritory(){
                this.territory_loading = true
                /**@params = skip,@params = limit,@params = search_key, @params = hierarchy_level*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: "",
                    hierarchy_level:'all'
                }
                let response = await this.getTerritoryList(params)
                this.territory_options = response.response
                this.territory_options = this.territory_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.territory_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.territory_count = this.territory_options.length
                this.territory_loading  = false
                this.territory_scrollable = false
            },
            //Lazy loading of the territories
            /**@params = reached */
            async reachedEndOfTerritories(reached) {
                this.territory_visible = reached
                if (reached) {
                    if (this.territory_scrollable == false) {
                        this.territory_loading = true
                        let response = await this.getTerritoryList({
                            skip: this.territory_count,
                            limit: 10,
                            search_key: "",
                            hierarchy_level:'all'
                        })
                        this.temp_territories = response.response.length;
                        if (response.skip == this.territory_count) {
                            if (this.temp_territories > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.territory_options.push(el);
                                });
                                this.territory_options = this.territory_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.territory_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.territory_count += response.response.length;
                                this.territory_loading = false
                            } else {
                                this.territory_scrollable = true
                                this.territory_loading = false
                            }
                        }
                        this.territory_loading = false
                    }
                }
            },
            limitTerritory(count){
                return `+ ${count} more`
            },
            //remove the territory
            /**@params = option */
            removeTerritory(option){
                this.temp_territories.forEach((el,index)=>{
                    if(el._id == option._id){
                        this.temp_territories.splice(index,1)
                    }
                })
            },
            //Api call to search products
            /**@params = item */
            async searchProducts(item) {
                this.products_loading = true
                /**@params = search_key */
                let params = {
                    search_key: item,
                }
                let response = await this.ListProducts(params)
                this.products_options = response.response
                this.products_count = this.products_options.length
                this.products_loading = false
                this.products_scrollable = false
                this.products_options.forEach(x => {
                    x['product_name'] = x.name
                    x['product_id'] = x.id
                    x['transition_value'] = 0
                })
            },
            //Lazy laoding functionality of the product
            /**@params = reached */
            async reachedEndOfProducts(reached) {
                this.products_visible = reached
                if (reached) {
                    if (this.products_scrollable == false) {
                        this.products_loading = true
                        let response = await this.ListProducts({
                            skip: this.products_count,
                            limit: 10
                        })
                        this.temp_products = response.response.length;
                        if (response.skip == this.products_count) {
                            if (this.temp_products > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.products_options.push(el);
                                });
                                this.products_options = this.products_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.products_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });

                                this.products_options.forEach(x => {
                                    x['product_name'] = x.name
                                    x['product_id'] = x.id
                                    x['transition_value'] = 0
                                })

                                this.products_count += response.response.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                        }
                        this.products_loading = false
                    }
                }
            },
            //show/hide point of contact tab
            showPointofContact() {
                this.contact_tab = !this.contact_tab
            },
            //show/hide point of info tab
            showAddInfo() {
                this.add_info_tab = !this.add_info_tab
            },
            //hide the create/update success modal and redirecting to the view customer
            hideSuccess() {
                this.sucess_customer = false;
                setTimeout(() => {
                    this.$router.push({
                        path: '/view_customer/' + this.customer_id
                    })
                }, 500);
            },
            //show/hide the customer info
            showCustomerInfo() {
                this.show_customer_details = !this.show_customer_details
            },
            //show/hide the company address
            showCompanyAddress() {
                this.show_company_address = !this.show_company_address
            },
            showAssociatedContact() {
                this.show_associated_contact = !this.show_associated_contact
            },
            contactPhoneInput({
                number,
                isValid,
                country
            }) {
                this.phone.number = number;
                this.phone.isValid = isValid;
                this.phone.country = country;
                this.contact_mobile_number.dial_code = this.phone.country.dialCode
                this.contact_mobile_number.country_code = this.phone.country.iso2
            },
            hideCompanyAddress() {
                this.add_company_address = false
            },
            //save/update company address
            saveCompanyAddress(value) {
                let address_value = value.address
                if (this.selected_company_address_index != null) {
                    this.address[this.selected_company_address_index].address.building_number = ""
                    this.address[this.selected_company_address_index].address.address_type = "mailing_address"
                    this.address[this.selected_company_address_index].address.city = address_value.city
                    this.address[this.selected_company_address_index].address.country = address_value.country
                    this.address[this.selected_company_address_index].address.state = address_value.state
                    this.address[this.selected_company_address_index].address.street = address_value.street
                    this.address[this.selected_company_address_index].address.zip_code = address_value.zip_code
                    this.address[this.selected_company_address_index].address.township = address_value.township
                    this.address[this.selected_company_address_index].address.latitude = address_value.latitude
                    this.address[this.selected_company_address_index].address.longitude = address_value.longitude
                    this.address[this.selected_company_address_index].customer_links = value.customer_links
                    this.address[this.selected_company_address_index].branch_name = value.branch_name
                    this.address[this.selected_company_address_index].alternate_emails = value.alternate_emails
                    this.address[this.selected_company_address_index].phone_number = value.phone_number
                } else if (this.selected_company_address_index == null) {
                    this.address.push({
                        address: {
                            building_number: "",
                            address_type: "mailing_address",
                            city: address_value.city,
                            country: address_value.country,
                            state: address_value.state,
                            street: address_value.street,
                            zip_code: address_value.zip_code,
                            township: address_value.township,
                            latitude: address_value.latitude || '0.00',
                            longitude: address_value.longitude || '0.00',
                        },
                        customer_links: value.customer_links,
                        alternate_emails: value.alternate_emails,
                        phone_number: value.phone_number,
                        branch_name: value.branch_name

                    })
                }
            },
            //add company address
            /**@params = index, @params = mode */
            addCompanyAddress(index, mode) {
                if(mode == 'add'){
                    this.hideAddBranchButton = true;
                }
                this.selected_company_address_index = index
                this.add_company_address = true
                localStorage.setItem("selected_company_address", null)
                if (this.selected_company_address_index != null) {
                    localStorage.setItem("selected_company_address", JSON.stringify(this.address[index]))
                }
                setTimeout(() => {
                    this.hideAddBranchButton = false;
                    this.$modal.show("addCompanyAddress");
                }, 500);
            },
            //delete company address
            /**@params = index */
            deleteAddress(index) {
                if (this.$route.params.id != 'new' && this.address[index].hasOwnProperty('id')) {
                    this.address[index]['is_deleted'] = true
                    this.address['count'] = this.address_length + 1
                    this.address_length = this.address.count
                    var get_add_section = document.getElementsByName('address-display')[index];
                    get_add_section.classList.add('address-none');
                } else if (this.$route.params.id == 'new' && !this.address[index].hasOwnProperty('id')) {
                    this.address.splice(index, 1);
                } else if (this.$route.params.id != 'new' && !this.address[index].hasOwnProperty('id')) {
                    this.address.splice(index, 1);
                }
                this.$forceUpdate()
            },
            //APi call to search Assigned
            /**@params = item */
            async searchAssignedDobouncer(item) {
                this.employees_loading = true
                /**@params = skip,@params = limit,@params = search_key,@params = company_id,@params = sort_key,@params = @params = sort_value  */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: item,
                    company_id: this.loggedInUser.company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let response = await this.getAssigned(params)
                this.sales_person_options = response.response
                this.employee_count = this.sales_person_options.length
                this.employees_loading = false
                this.employee_scrollable = false
            },
            //lazy loading of employees
            /**@params = reached */
            async reachedEndOfEmployees(reached) {
                this.employee_visible = reached
                if (reached) {
                    if (this.employee_scrollable == false) {
                        this.employees_loading = true
                        let response = await this.getAssigned({
                            skip: this.employee_count,
                            limit: 10,
                            search_key: "",
                            company_id: this.loggedInUser.company_id,
                            sort_key:'full_name',
                            sort_value:1
                        })
                        this.temp_employees = response.response.length;
                        if (response.skip == this.employee_count) {
                            if (this.temp_employees > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.sales_person_options.push(el);
                                });
                                this.sales_person_options = this.sales_person_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.sales_person_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.employee_count += response.response.length;
                                this.employees_loading = false
                            } else {
                                this.employee_scrollable = true
                                this.employees_loading = false
                            }
                        }
                        this.employees_loading = false
                    }
                }
            },
            //check the validation of the address
            addressCheck(){
                if(this.address.length == 0 || this.address.length == this.address_length){
                    document.getElementById('addressCheck').innerHTML = "Address is required";
                }
            },
            //clear the validation of the address
            clearAddressCheck(){
                    document.getElementById('addressCheck').innerHTML = "";
            },
            handleValidationError() {
                const firstField = Object.keys(this.errors.collect())[0];
                if(firstField.includes('multiselect')) {
                    this.$refs[`${firstField}Input`].$el.focus();
                } else {
                    this.$refs[`${firstField}Input`].focus();
                }
            },
            //save/udpate customer data
            saveCustomer() {
                this.$validator.validateAll().then(async result => {
                    if (result == true && this.check_customer.status_id != 0 ) {
                        this.disableButtonAndDisplayLoader = true;
                        this.temp_company_name = this.company_name.name ? this.company_name.name : this.company_name
                        if(this.temp_company_name.length > 50){
                            this.warning_msg = "Company Name exceeded limit 50 character"
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$refs.warning_modal.close();
                            }, 3000);
                        } else if(this.address.length > 0 && this.address.length != this.address_length && !this.selectedData){
                            this.create_customer.customer_branches.forEach(x => {
                                if (x.hasOwnProperty('customer_links') && x.customer_links.length ==
                                    0) {
                                    //delete x.customer_links
                                }
                                if (x.hasOwnProperty('alternate_emails') && x.alternate_emails.length ==
                                    0) {
                                // delete x.alternate_emails
                                }
                                if (x.hasOwnProperty('phone_number') && x.phone_number.length && x
                                    .phone_number.phone_number == '') {
                                    delete x.phone_number
                                }
                            })
                            if (this.additional_info.length) {
                                let temp_additional_fields = []
                                this.additional_info.forEach(x => {
                                    if (x.value && typeof x.value === 'object') {
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value.value
                                        })
                                    } else if (x.value && typeof x.value !== 'object') {
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value
                                        })
                                    }
                                })
                                this.create_customer['additional_info'] = temp_additional_fields
                            }
                            if (this.$route.params.id == 'new') {
                                try{
                                    let response = await this.createCustomer(this.create_customer)
                                    this.customer_id = response.id
                                    this.sucess_customer = true;
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$modal.show('success-message');
                                    }, 1000)
                                } catch(error) {
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            } else {
                                try{
                                    this.create_customer.poc_details = {
                                        id: this.point_of_contact_id,
                                        first_name: this.point_of_contact_first_name,
                                        last_name: this.point_of_contact_last_name,
                                        primary_email: this.email,
                                        phone_number: this.contact_mobile_number
                                    }
                                    //this.create_customer['id'] = this.$route.params.id
                                    let response = await this.editCustomer(this.$route.params.id, this.create_customer)
                                    this.customer_id = this.$route.params.id
                                    this.sucess_customer = true;
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$modal.show('success-message');
                                    }, 1000)
                                } catch(error) {
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            }
                        }
                        else if(this.selectedData){
                            if (this.additional_info.length) {
                                let temp_additional_fields = []
                                this.additional_info.forEach(x => {
                                    if (x.value && typeof x.value === 'object') {
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value.value
                                        })
                                    } else if (x.value && typeof x.value !== 'object') {
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value
                                        })
                                    }
                                })
                                this.create_customer['additional_info'] = temp_additional_fields
                            }
                            if (this.$route.params.id == 'new') {
                                try{
                                    let response = await this.createCustomer(this.create_customer)
                                    this.customer_id = response.id
                                    this.sucess_customer = true;
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$modal.show('success-message');
                                    }, 1000)
                                } catch(error) {
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            } else {
                                try{
                                    this.create_customer.poc_details = {
                                        id: this.point_of_contact_id,
                                        first_name: this.point_of_contact_first_name,
                                        last_name: this.point_of_contact_last_name,
                                        primary_email: this.email,
                                        phone_number: this.contact_mobile_number
                                    }
                                    //this.create_customer['id'] = this.$route.params.id
                                    let response = await this.editCustomer(this.$route.params.id, this.create_customer)
                                    this.customer_id = this.$route.params.id
                                    this.sucess_customer = true;
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$modal.show('success-message');
                                    }, 1000)
                                } catch(error) {
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            }
                        }
                        this.disableButtonAndDisplayLoader = false;
                    } else{
                        return this.handleValidationError();
                    }
                })
            },
            cancel() {
                this.$router.go(-1)
            },
            //load customer details
            async loadCustomerDetails() {
                this.ajaxCallInProgress = true
                let response = await this.getCustomerDetails(this.$route.params.id)
                this.customer_branches = response.response
                this.subsidiary_company_id = this.customer_branches.subsidiary_company_id
                this.company_name = this.customer_branches.customer_name
                this.customer_type = this.customer_branches.customer_type == 'domestic' ? 'Domestic' :
                    'International'
                this.branch_name = this.customer_branches.customer_branches.branch_name
                this.company_branch = this.customer_branches.customer_branches
                this.territory = {name: this.customer_branches.territory, id: this.customer_branches.territory_id}
                this.customer_status = this.customer_branches.customer_status == 'existing' ? 'Existing Customer' :
                    this.customer_branches.customer_status == 'new' ? 'New Customer' : this.customer_branches
                    .customer_status == 'follow_up' ? 'Follow Up' : 'Demo',
                    this.industry_type = this.customer_branches.industry_type
                this.primary_email = this.customer_branches.primary_email
                this.no_of_employees = this.customer_branches.no_of_employees
                this.tax_id = this.customer_branches.tax_id
                this.point_of_contact_id = this.customer_branches.poc_details.id
                this.point_of_contact_first_name = this.customer_branches.poc_details.first_name
                this.point_of_contact_last_name = this.customer_branches.poc_details.last_name
                //this.email =  this.customer_branches.poc_details.primary_email
                this.email = this.customer_branches.poc_details.primary_email
                this.contact_mobile_number = {
                    phone_number: this.customer_branches.poc_details.phone_number.phone_number,
                    dial_code: this.customer_branches.poc_details.phone_number.dial_code || "",
                    country_code: this.customer_branches.poc_details.phone_number.country_code,
                    phone_type: this.customer_branches.poc_details.phone_number.phone_type
                }
                this.customer_branches.customer_branches.forEach(x => {
                    this.customer_mobile_number = {
                        phone_number: x.phone_number.phone_number,
                        dial_code: x.phone_number.dial_code || "",
                        country_code: x.phone_number.country_code,
                        phone_type: x.phone_number.phone_type
                    }
                })
                this.sales_person = {
                    id: this.customer_branches.sales_person_id,
                    full_name: this.customer_branches.sales_person_name
                }
                this.formatted_date = this.customer_branches.customer_date
                this.address = this.customer_branches.customer_branches
                this.formatted_time = this.customer_branches.customer_time
                this.ajaxCallInProgress = false
                this.additional_info.forEach(x => {
                    this.customer_branches.additional_info.forEach(y => {
                        if (x._id == y.id) {
                            if (x.field_type == 'selection_field') {
                                if (x.data_type == 'radio_button') {
                                    x.value = y.value
                                } else {
                                    x.value = {
                                        value: y.value
                                    }
                                }
                            } else {
                                x.value = y.value
                            }
                        }
                    })
                })

                if(this.subsidiary_company_id!= ''){
                    this.addCompanyDepartment(this.subsidiary_company_id)
                    this.reachedEndOfPoc()
                }
                if(this.subsidiary_company_id!=''){
                    this.department_name = {
                        id: this.customer_branches.department_id,
                        name: this.customer_branches.department_name
                    }
                } else{
                    this.department_name = this.customer_branches.department_name
                }
                this.$forceUpdate()
            },
            //Api call to load Additional info data
            async loadAdditionalInfo() {
                //this.ajaxCallInProgress = true
               /**@params = limit,@params = search_key,@params =skip ,@params =sort_key ,@params = sort_value,@params = sub_module_name */
                let params = {
                    limit: 50,
                    search_key: "",
                    skip: 0,
                    sort_key: "",
                    sort_value: -1,
                    sub_module_name: "customers"
                }
                let response = await this.getAdditionalInformationList(params)
                this.additional_info = response.response
                this.additional_info.forEach(x => {
                    x['value'] = null
                })
                //this.ajaxCallInProgress = false
                if (this.$route.params.id != 'new') {
                    this.loadCustomerDetails()
                }
                if (this.additional_info.length) {
                    this.check_visibility = this.additional_info.every(x => x.visibility === false)
                }
            }
        },
        mounted() {
            if (this.$route.params.id != 'new') {
                this.ajaxCallInProgress = true;
            }
            this.loadAdditionalInfo()
            this.loadCompanyName();
            // this.fetchCompanyName()
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            //create customer
            create_customer() {
                let dept_name
                let cust_name
                if(this.$route.params.id == 'new' && this.selectedDept || this.$route.params.id != 'new' &&  this.subsidiary_company_id !=''){
                    dept_name = this.department_name.name
                } else {
                    dept_name = this.department_name
                }
                if(this.$route.params.id == 'new' && this.company_name.company_id != '' ){
                    cust_name = this.company_name.name
                } else if(this.$route.params.id == 'new' && this.company_name.company_id == '' || this.$route.params.id != 'new' && this.company_name.company_id != '' ) {
                    cust_name = this.company_name
                }
                if(this.associated_contact.length != 0){
                    this.associated_contact.forEach(x => {
                        this.temp_associated_contact.push(x.contact_name.id)
                    })
                }
                return {
                    customer_pic: {
                        "url":this.pic_type == 'avatar' ? this.avatar_pic : this.profile_pic,
                        "profile_image_type": this.pic_type,
                    },
                    associated_contacts: this.temp_associated_contact ? this.temp_associated_contact : [],
                    subsidiary_company_id: this.company_name.company_id || this.subsidiary_company_id || "",
                    customer_name: cust_name,
                    customer_type: this.customer_type.toLowerCase() || "",
                    branch_name: this.branch_name,
                    department_name: dept_name || "",
                    customer_status: this.customer_status == 'Existing Customer' ? 'existing' : this.customer_status ==
                        'New Customer' ? 'new' : this.customer_status == 'Follow Up' ? 'follow_up' : 'demo',
                    industry_type: this.industry_type,
                    tax_id: this.tax_id,
                    sales_person_id: this.sales_person.id || "",
                    sales_person_name: this.sales_person.full_name || "",
                    primary_email: this.primary_email.toLowerCase(),
                    no_of_employees: this.no_of_employees,
                    customer_date: this.formatted_date,
                    customer_time: this.formatted_time,
                    customer_branches: this.address,
                    poc_details: {
                        first_name: this.point_of_contact_first_name,
                        last_name: this.point_of_contact_last_name,
                        primary_email: this.email,
                        phone_number: this.contact_mobile_number
                    },
                    territory_id: this.territory.id,

                }
            },
            userPermissions() {
                return this.$store.getters.userPermissions;
            }
        },
        created() {
            this.searchTerritory = debounce(this.searchTerritoryDobouncer, 500)
            this.searchAssigned = debounce(this.searchAssignedDobouncer, 500)
            this.searchPoc = debounce(this.searchPocDobouncer, 500)
            this.searchCompanyName = debounce(this.searchCompanyNameDobouncer, 500)
            const dict = {
                custom: {
                    company_name: {
                        required: () => "Company Name is required"
                    },
                    department_name: {
                        required: () => "Department Name is required"
                    },
                    customer_status_multiselect: {
                        required: () => "Customer Status is required"
                    },
                    industry_type_multiselect: {
                        required: () => "Industry Type is required"
                    },
                    email: {
                        required: () => "Primary Email is required",
                        email: () => "Please Enter Valid Email Address"
                    },
                    contact_mobile_number: {
                        required: () => "Contact Mobile Number is required",
                        min: () => "Contact Mobile Number must contain more than 9 numbers",
                    },
                    primary_email: {
                        email: () => "Please Enter Valid Email Address"
                    }
                }
            };
            this.$validator.localize("en", dict);
        }
    }
</script>
<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .map-location {
        cursor: pointer;
        height: 48px;
        padding-top: 7px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .overflow-auto {
        overflow: auto;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }

    .new-field-btn {
        color: #fff;
        background-color: #008a63;
    }

    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        font-size: 14px !important;
        font-weight: 600;
        color: #303031 !important;
    }
    .input-field::placeholder{
        color: #4e5764 !important;
		display: inline-block;
		margin-bottom: 7px !important;
		padding-top: 5px;
		padding-left: 5px !important;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
        font-weight: 400 !important;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .btn-new-cancel {
        color: #d51650;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 600;
        border: 1px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }

    .btn-new-save {
        border: 2px solid #008a63;
        line-height: 30px;
        border-radius: 5px;
        background-color: #008a63 !important;
    }

    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }

    .mx-input {
        /* border-bottom: 1px solid #fff !important; */
        display: inline-block;
        height: 0px !important;
    }

    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }

    .secondary_row {
        width: 200px
    }

    .header-outer {
        width: 100%;
        background: #00448b;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .view-contact-tab {
        padding: 10px 20px 10px 20px;
    }

    .text-green {
        color: #448e4d !important;
    }

    .pointer-event {
        background-color: #fff !important;
    }

    .input-date-position {
        position: relative;
        bottom: 7px;
    }

    .remainder-list {
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px;
        height: 120px
    }

    .text-flow {
        overflow-wrap: anywhere;
    }

    .text-secondary {
        color: #00448b !important;
    }

    .text-line {
        text-decoration: none !important;
    }

    .w-200px {
        /* width: 100px; */
        max-width: 230px;
    }
    .address-none{
        display: none;
    }
    .contact-none{
        display: none;
    }
    .address-card-height {
        overflow-y: scroll;
        overflow-x: scroll;
        max-height: 230px;
        min-height:171px;
    }
    .text-padding{
        padding-right:32px !important;
    }
    @media screen and (max-width: 767px) {
		.margin-top-res {
            margin-top: 20px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Customers/CreateCustomer.vue